import * as React from 'react';
import { Grid } from '@mui/material';
import AppService, { position } from '../services/app.service';

interface Props {
  id?: string;
  color?: any;
  colorOther?: any;
  position?: position;
  children?: React.ReactNode;
}

export const Trapezoid: React.FunctionComponent<Props> = (props) => {
  const isMobile = AppService.isMobile();

  const createPolygon = () => {
    const adjHeight = isMobile? 50 : 100;

    //`polygon(topLeft(x,y), topRight(x,y), bottomRight(x,y), bottomLeft(x,y))`
    switch (props.position){
      case 'topLeft': return `polygon(0 0, 100% ${adjHeight}px, 100% 100%, 0 100%)`;
      case 'topRight': return `polygon(0 ${adjHeight}px, 100% 0, 100% 100%, 0 100%)`;
      case 'bottomLeft': return `polygon(0 0, 100% 0, 100% calc(100% - ${adjHeight}px), 0 100%)`;
      case 'bottomRight': return `polygon(0 0, 100% 0, 100% 100%, 0 calc(100% - ${adjHeight}px))`;
      default: return `polygon(0 0, 100% 0, 100% 100%, 0 100%)`;      
    }
  }
      
  return (        
    <Grid id='box' bgcolor={props.colorOther || props.color}>
      <Grid id={props.id} sx={{height: 'auto', backgroundColor: props.color || 'background.default', clipPath: createPolygon()}} pt={props.position?.includes('topLeft')? 10 : 0} pb={props.position?.includes('bottomLeft')? 10 : 0}> 
        {props.children}
      </Grid>
    </Grid>
  );
}
